import { HttpParams, HttpEvent } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractHttpService } from '../../service/http-abstract-service';
import { AccountDetailsDto } from './dto';


@Injectable({
	providedIn: 'root'
})
export class HttpAccountService extends AbstractHttpService {

	constructor(http: HttpClient) {
		super(http, '/account');
	}

	getAll(): Observable<AccountDetailsDto[]> {
		return super.get(`/list`);
	}
}
